import { render, staticRenderFns } from "./BTheme.vue?vue&type=template&id=ede04eac&scoped=true&"
import script from "./BTheme.vue?vue&type=script&lang=js&"
export * from "./BTheme.vue?vue&type=script&lang=js&"
import style0 from "./BTheme.vue?vue&type=style&index=0&id=ede04eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede04eac",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle});
